import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "staffFormIsOpen", false);
        Vue.set(state, "staffGridIsOpen", true);
        Vue.set(state, "educationFormIsOpen", false);
        Vue.set(state, "educationGridIsOpen", true);
        Vue.set(state, "feeFormIsOpen", false);
        Vue.set(state, "feeGridIsOpen", true);
    },
    setStaffFormOpen(state) {
        state.staffFormIsOpen = true;
        state.staffGridIsOpen = false;
    },
    setStaffFormClose(state) {
        state.staffFormIsOpen = false;
        state.staffGridIsOpen = true;
    },

    setEducationFormOpen(state) {
        state.educationFormIsOpen = true;
        state.educationGridIsOpen = false;
    },
    setEducationFormClose(state) {
        state.educationFormIsOpen = false;
        state.educationGridIsOpen = true;
    },

    setFeeFormOpen(state) {
        state.feeFormIsOpen = true;
        state.feeGridIsOpen = false;
    },
    setFeeFormClose(state) {
        state.feeFormIsOpen = false;
        state.feeGridIsOpen = true;
    }
}
